import { ExternalDocument } from '@modusign/openapi-client-external-document/generated/model';
import { GetTemplatesResponseTemplate } from '@modusign/openapi-client-template/model';
import mapValues from 'lodash/mapValues';

import { LabelsLabelingState } from '@app/features/label/components/LabelPopovers/context/types';
import VisibleDocument from '@app/store/documents/VisibleDocument';

type LabeledResource = VisibleDocument | ExternalDocument | GetTemplatesResponseTemplate;

export function getLabelsLabelingState(labeledResources: LabeledResource[]): LabelsLabelingState {
  const labelCountById: Record<string, number> = labeledResources
    .flatMap((d) => d.labels)
    .reduce<Record<string, number>>((acc, label) => {
      acc[label.id] = (acc[label.id] || 0) + 1;
      return acc;
    }, {});

  return mapValues(labelCountById, (count) => (count === labeledResources.length ? 'ALL' : 'SOME'));
}
